import { c as _c } from "react/compiler-runtime";
import { useObservableSyncedQuery } from '@legendapp/state/sync-plugins/tanstack-react-query';
import localForage from 'localforage';
export function usePersistedValue(key, initialValue) {
  const $ = _c(14);
  let t0;
  if ($[0] !== key) {
    t0 = ["persisted-value", key];
    $[0] = key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryKey = t0;
  let t1;
  if ($[2] !== key) {
    t1 = async () => {
      const value = await localForage.getItem(key);
      return value || null;
    };
    $[2] = key;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== initialValue || $[5] !== queryKey || $[6] !== t1) {
    t2 = {
      queryKey,
      queryFn: t1,
      initialData: initialValue
    };
    $[4] = initialValue;
    $[5] = queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== key || $[9] !== queryKey) {
    t3 = {
      mutationFn: async (value_0, context) => {
        await localForage.setItem(key, value_0);
        await context.client.invalidateQueries({
          queryKey
        });
        return value_0;
      }
    };
    $[8] = key;
    $[9] = queryKey;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = {
      query: t2,
      mutation: t3
    };
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return useObservableSyncedQuery(t4);
}